export default class OrdersService {
  constructor(Api) {
    "ngInject"
    this.api = Api;

  }

  loadOrders(data) {
    let
      url = '/orders/list';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  getOrder(id) {
    return this.api.call({
      method: 'get',
      url: '/orders/get/' + id
    })
  }

  getItems(id) {
    return this.api.call({
      method: 'get',
      url: '/orders/items/' + id
    })
  }

  getOrderStatusLogs(id) {
    return this.api.call({
      method: 'get',
      url: '/orders/statusLogs/' + id
    })
  }

  updateOrderStatus(data) {
    let
      url = '/orders/updateStatus';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  resetOrderStatus(id) {
    return this.api.call({
      method: 'get',
      url: '/orders/resetOrderStatus/' + id
    })
  }

  updateInvoiceId(data) {
    let
      url = '/orders/updateInvoiceId';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  getComments(id) {
    return this.api.call({
      method: 'get',
      url: '/orders/comments/' + id
    })
  }

  saveComments(data) {
    let
      url = '/orders/saveComment';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  removeComment(id) {
    let
      url = `/orders/removeComment/${id}`;
    return this.api.call({
      method: 'delete',
      url
    })
  }

  sendShippedMail(id) {
    let
      url = `/orders/sendShippedMail/${id}`;
    return this.api.call({
      method: 'get',
      url
    })
  }

  sendInvoiceMail(id) {
    let
      url = `/orders/sendInvoiceMail/${id}`;
    return this.api.call({
      method: 'get',
      url
    })
  }

  sendCollectionMail(id) {
    let
      url = `/orders/sendCollectionMail/${id}`;
    return this.api.call({
      method: 'get',
      url
    })
  }

  sendReceiptMail(id) {
    let
      url = `/orders/sendReceiptMail/${id}`;
    return this.api.call({
      method: 'get',
      url
    })
  }

  sendReviewMail(id) {
    let
      url = `/orders/sendReviewMail/${id}`;
    return this.api.call({
      method: 'get',
      url
    })
  }

  sendPaperInvoiceMail(id) {
    let
      url = `/orders/sendPaperInvoiceMail/${id}`;
    return this.api.call({
      method: 'get',
      url
    })
  }

  sendReminderInvoiceMail(id) {
    let
      url = `/orders/sendReminderInvoiceMail/${id}`;
    return this.api.call({
      method: 'get',
      url
    })
  }

  saveShipmentResp(data) {
    let
      url = '/orders/saveShipmentResp';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }

  tosvg(data) {
    let
      url = '/orders/tosvg';
    return this.api.call({
      method: 'post',
      url,
      data: data,
      headers: {
        "Content-Type": 'application/json'
      }
    })
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/orders/services/order.service.js
 **/